(function () {
  var NOTIFY_TEXT = 'Повідомити про наявність';

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return (cents / 100).toLocaleString('uk-UA', { style: 'currency', currency: 'UAH' });
  }

  window._notifyState = { title: '', price: '', available: true, _originalText: '', _productId: '' };

  var _btnObserver = null;
  var _applyScheduled = false;
  var _scrollY = 0;

  // Основна кнопка товару (НЕ sticky — sticky стоїть у DOM раніше і теж має ref="addToCartButton")
  function getMainBtn() {
    return document.querySelector('add-to-cart-component [ref="addToCartButton"]')
      || document.querySelector('button.add-to-cart-button:not(.sticky-add-to-cart__button)');
  }

  function getMainAtc() {
    var b = getMainBtn();
    return (b && b.closest('add-to-cart-component')) || document.querySelector('add-to-cart-component');
  }

  function btnLabel(btn) {
    var el = btn && btn.querySelector('.actual-btn-text');
    return el ? el.textContent.trim() : '';
  }

  function lockScroll() {
    if (document.body.classList.contains('notify-open')) return;
    _scrollY = window.scrollY;
    document.body.style.top = '-' + _scrollY + 'px';
    document.body.classList.add('notify-open');
  }

  function unlockScroll() {
    if (!document.body.classList.contains('notify-open')) return;
    document.body.classList.remove('notify-open');
    document.body.style.top = '';
    document.body.style.overflow = '';
    window.scrollTo(0, _scrollY);
  }

  function getFreshTitle() {
    var btn = getMainBtn();
    if (btn && btn.dataset.productTitle) return btn.dataset.productTitle;
    var atc = getMainAtc();
    if (atc && atc.dataset.productTitle) return atc.dataset.productTitle;
    return window._notifyState.title || '';
  }

  function getFreshPrice() {
    var btn = getMainBtn();
    if (btn && btn.dataset.productPrice) return btn.dataset.productPrice;
    var atc = getMainAtc();
    if (atc && atc.dataset.productPrice) return atc.dataset.productPrice;
    return window._notifyState.price || '';
  }

  function fillDrawer(title, price) {
    var t = document.getElementById('NotifyProductTitle');
    var p = document.getElementById('NotifyProductPrice');
    var i = document.getElementById('NotifyProductInput');
    if (t) t.textContent = title;
    if (p) p.textContent = price;
    if (i) i.value = title;
  }

  function resolveProductId() {
    if (window._notifyState._productId) return window._notifyState._productId;
    var picker = document.querySelector('[ref="mainVariantPicker"]');
    if (picker && picker.dataset.productId) return (window._notifyState._productId = picker.dataset.productId);
    var sticky = document.querySelector('sticky-add-to-cart[data-product-id]');
    if (sticky) return (window._notifyState._productId = sticky.dataset.productId);
    return '';
  }

  window.openNotifyDrawer = function (title, price) {
    var t = title || getFreshTitle() || '';
    var p = price || getFreshPrice() || '';
    fillDrawer(t, p);
    window._notifyState.title = t;
    window._notifyState.price = p;
    var drawer = document.getElementById('NotifyDrawer');
    var overlay = document.getElementById('NotifyOverlay');
    if (!drawer || !overlay) { console.warn('NotifyDrawer не знайдено'); return; }
    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-active');
    overlay.classList.add('is-active');
    lockScroll();
    var pid = resolveProductId();
    if (pid) loadRecommendations(pid);
  };

  function closeDrawer() {
    var drawer = document.getElementById('NotifyDrawer');
    var overlay = document.getElementById('NotifyOverlay');
    if (!drawer || !overlay) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-active', 'is-open');
    overlay.classList.remove('is-active', 'is-open');
    unlockScroll();
  }
  window.closeNotifyDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    if (e.target.closest('.js-notify-close')) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ===== Єдиний обробник «Повідомити про наявність» для основної, sticky та карткових кнопок =====
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button.add-to-cart-button, button.sticky-add-to-cart__button');
    if (!btn || btn.classList.contains('is-unselected-state')) return;
    if (btn.getAttribute('name') !== 'notify' && btnLabel(btn) !== NOTIFY_TEXT) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    btn.disabled = false;

    var host = btn.closest('add-to-cart-component');
    if (!host && btn.closest('sticky-add-to-cart')) host = getMainAtc();
    var title = (host && host.dataset.productTitle) || btn.dataset.productTitle || '';
    var price = (host && host.dataset.productPrice) || btn.dataset.productPrice || '';
    window.openNotifyDrawer(title, price);
  }, true);

  function loadRecommendations(productId) {
    var container = document.getElementById('NotifyRecommendationsContainer');
    var prevBtn = document.getElementById('NotifyRecPrev');
    var nextBtn = document.getElementById('NotifyRecNext');
    if (!container || !productId) return;
    container.innerHTML = '';
    if (prevBtn) prevBtn.classList.add('is-hidden');
    if (nextBtn) nextBtn.classList.add('is-hidden');
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products;
        if (!products || !products.length) return;
        container.innerHTML = products.map(function (p) {
          var rawImg = (typeof p.featured_image === 'string' ? p.featured_image : '')
            || (p.images && p.images[0] ? p.images[0] : '')
            || (p.media && p.media[0] ? p.media[0].src : '');
          var img = rawImg ? ('https:' + rawImg.replace(/^https?:/, '')) : '';
          img = img.replace(/(\.(png|jpg|jpeg|gif|webp))(\?|$)/i, '_300x$1$3');
          var price = p.variants && p.variants[0] ? p.variants[0].price : 0;
          var isNew = p.tags && p.tags.indexOf('new') !== -1;
          var priceFormatted = (price / 100).toLocaleString('uk-UA') + '\u00a0\u20b4';
          return '<a href="' + p.url + '" class="notify-rec__card">'
            + '<div class="notify-rec__image">'
            + (img ? '<img src="' + img + '" alt="' + p.title + '" loading="lazy">' : '<div style="width:100%;height:100%;background:#f0f0f0"></div>')
            + (isNew ? '<span class="notify-rec__badge">NEW</span>' : '')
            + '</div>'
            + '<div class="notify-rec__info">'
            + '<p class="notify-rec__name">' + p.title + '</p>'
            + '<p class="notify-rec__price">' + priceFormatted + '</p>'
            + '</div>'
            + '</a>';
        }).join('');
        setTimeout(function () {
          var canScroll = container.scrollWidth > container.clientWidth + 10;
          if (prevBtn) prevBtn.classList.add('is-hidden');
          if (nextBtn) nextBtn.classList.toggle('is-hidden', !canScroll);
        }, 100);
        if (!container._scrollBound) {
          container._scrollBound = true;
          container.addEventListener('scroll', function () {
            if (!prevBtn || !nextBtn) return;
            prevBtn.classList.toggle('is-hidden', container.scrollLeft < 10);
            nextBtn.classList.toggle('is-hidden', container.scrollLeft + container.clientWidth >= container.scrollWidth - 10);
          });
        }
      })
      .catch(function () { container.innerHTML = ''; });
  }

  document.addEventListener('click', function (e) {
    var track;
    if (e.target.closest('#NotifyRecNext')) {
      track = document.getElementById('NotifyRecommendationsContainer');
      if (track) { var c1 = track.querySelector('.notify-rec__card'); track.scrollBy({ left: (c1 ? c1.offsetWidth + 10 : 200) * 2, behavior: 'smooth' }); }
    }
    if (e.target.closest('#NotifyRecPrev')) {
      track = document.getElementById('NotifyRecommendationsContainer');
      if (track) { var c2 = track.querySelector('.notify-rec__card'); track.scrollBy({ left: -(c2 ? c2.offsetWidth + 10 : 200) * 2, behavior: 'smooth' }); }
    }
  });

  function initOriginalText() {
    var btn = getMainBtn();
    if (!btn) return;
    var t = btnLabel(btn);
    if (t && t !== NOTIFY_TEXT && !window._notifyState._originalText) window._notifyState._originalText = t;
  }

  function isUnselectedState(btn) {
    return btn && btn.classList.contains('is-unselected-state');
  }

  function setButtonUnavailable(btn) {
    if (!btn || isUnselectedState(btn)) return;
    btn.setAttribute('type', 'button');
    btn.removeAttribute('name');
    btn.removeAttribute('disabled');
    btn.disabled = false;
    btn.removeAttribute('onclick'); // клік обробляє єдиний делегат вище
    var textEl = btn.querySelector('.actual-btn-text');
    if (textEl && textEl.textContent.trim() !== NOTIFY_TEXT) textEl.textContent = NOTIFY_TEXT;
  }

  function setButtonAvailable(btn) {
    if (!btn || isUnselectedState(btn)) return;
    btn.setAttribute('type', 'submit');
    btn.setAttribute('name', 'add');
    btn.removeAttribute('onclick');
    var textEl = btn.querySelector('.actual-btn-text');
    var expected = window._notifyState._originalText || (window.camotecStrings && window.camotecStrings.addToCart) || 'Додати в кошик';
    if (textEl && textEl.textContent.trim() !== expected) textEl.textContent = expected;
  }

  function applyButtonState(available, title, price) {
    var btn = getMainBtn();
    if (!btn || isUnselectedState(btn)) return;

    window._notifyState.title = title;
    window._notifyState.price = price;
    window._notifyState.available = available;

    if (_btnObserver) { _btnObserver.disconnect(); _btnObserver = null; }

    if (!available) setButtonUnavailable(btn);
    else setButtonAvailable(btn);

    _btnObserver = new MutationObserver(function (muts) {
      if (_applyScheduled) return;
      var currentBtn = getMainBtn();
      if (!currentBtn || isUnselectedState(currentBtn)) return;
      var needsCorrection = false;
      muts.forEach(function (m) {
        if (m.type === 'characterData' || m.type === 'childList') {
          var currentText = btnLabel(currentBtn);
          if (!window._notifyState.available && currentText !== NOTIFY_TEXT) needsCorrection = true;
          if (window._notifyState.available && currentText === NOTIFY_TEXT) needsCorrection = true;
        }
      });
      if (needsCorrection) {
        _applyScheduled = true;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            var b = getMainBtn();
            if (b && !isUnselectedState(b)) {
              if (!window._notifyState.available) setButtonUnavailable(b);
              else setButtonAvailable(b);
            }
            _applyScheduled = false;
          });
        });
      }
    });
    _btnObserver.observe(btn, { childList: true, subtree: true, characterData: true });

    var drawer = document.getElementById('NotifyDrawer');
    if (drawer && drawer.classList.contains('is-active')) fillDrawer(title, price);
  }

  function initFromVariantId() {
    var urlParams = new URLSearchParams(window.location.search);
    var variantId = urlParams.get('variant');
    var atc = getMainAtc();
    var title = atc ? (atc.dataset.productTitle || '') : '';
    var price = atc ? (atc.dataset.productPrice || '') : '';
    resolveProductId();
    var btn = getMainBtn();
    if (btn && isUnselectedState(btn)) return;
    if (variantId) {
      fetch('/variants/' + variantId + '.js')
        .then(function (r) { return r.json(); })
        .then(function (variant) {
          if (variant.product_id) window._notifyState._productId = String(variant.product_id);
          applyButtonState(variant.available, title, price);
        })
        .catch(function () {});
    } else if (btn) {
      var isAvailable = btn.getAttribute('name') === 'add' && btnLabel(btn) !== NOTIFY_TEXT;
      applyButtonState(isAvailable, title, price);
    }
  }

  document.addEventListener('variant:update', function (e) {
    var detail = e.detail;
    if (!detail || !detail.resource) return;
    var res = detail.resource;
    var available = typeof res.available !== 'undefined' ? res.available : true;
    var price = res.price ? formatMoney(res.price) : '';
    var picker = document.querySelector('[ref="mainVariantPicker"]');
    if (picker && picker.dataset.productId) window._notifyState._productId = picker.dataset.productId;
    var btn = getMainBtn();
    if (btn && btn.classList.contains('is-unselected-state')) {
      btn.classList.remove('is-unselected-state');
      btn.removeAttribute('onclick');
    }
    [150, 400, 800].forEach(function (delay) {
      setTimeout(function () {
        var b = getMainBtn();
        if (!b || isUnselectedState(b)) return;
        var atc = b.closest('add-to-cart-component') || getMainAtc();
        var freshTitle = (atc && atc.dataset.productTitle) || b.dataset.productTitle || '';
        var finalPrice = price || (atc ? atc.dataset.productPrice || '' : '');
        initOriginalText();
        applyButtonState(available, freshTitle, finalPrice);
      }, delay);
    });
  });

  var atcEl = getMainAtc();
  if (atcEl) {
    new MutationObserver(function () {
      if (!window._notifyState.available) {
        var btn = getMainBtn();
        window._notifyState.title = (btn && btn.dataset.productTitle) || atcEl.dataset.productTitle || '';
        window._notifyState.price = (btn && btn.dataset.productPrice) || atcEl.dataset.productPrice || '';
      }
    }).observe(atcEl, { attributes: true, attributeFilter: ['data-product-title', 'data-product-price'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initOriginalText(); setTimeout(initFromVariantId, 500); });
  } else {
    initOriginalText();
    setTimeout(initFromVariantId, 500);
  }
})();